import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { api, trackPage } from "../lib/api";
import { subscribeContentUpdates } from "../lib/contentSync";
import Prestasi from "../components/landing/Prestasi";
import CategoryScoreboard from "../components/landing/CategoryScoreboard";

const CATEGORY_OPTIONS = ["Semua", "Speed", "Standart", "Slalom"];

export default function PrestasiList() {
    const [content, setContent] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedCategory = CATEGORY_OPTIONS.includes(searchParams.get("category")) ? searchParams.get("category") : "Semua";

    useEffect(() => {
        trackPage("/prestasi");
        const load = () => {
            api.get("/content")
                .then((r) => setContent(r.data))
                .catch(() => setContent({ achievements: [], athletes: [] }));
        };
        load();
        return subscribeContentUpdates(load);
    }, []);

    const chooseCategory = (category) => {
        if (category === "Semua") setSearchParams({});
        else setSearchParams({ category });
    };

    const achievements = content?.achievements || [];
    const filteredAchievements = selectedCategory === "Semua"
        ? achievements
        : achievements.filter((achievement) => achievement.category === selectedCategory);

    return (
        <div className="min-h-screen bg-[#FBF9F5]" data-testid="prestasi-list-page">
            <div className="max-w-7xl mx-auto px-6 md:px-10 pt-8">
                <Link to="/" data-testid="prestasi-back-home" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-racing-muted hover:text-racing-red transition-colors">
                    <ArrowLeft size={16} /> Kembali ke Beranda
                </Link>
                <div className="mt-8 flex flex-wrap gap-2" data-testid="prestasi-category-filters">
                    {CATEGORY_OPTIONS.map((category) => (
                        <button
                            key={category}
                            type="button"
                            onClick={() => chooseCategory(category)}
                            data-testid={`prestasi-category-filter-${category.toLowerCase()}`}
                            className={`px-5 py-3 text-xs uppercase tracking-[0.2em] border transition-colors duration-300 ${
                                selectedCategory === category
                                    ? "bg-racing-red border-racing-red text-white"
                                    : "bg-white border-racing-line text-racing-muted hover:text-neutral-900 hover:border-black/30"
                            }`}
                        >
                            {category}
                        </button>
                    ))}
                </div>
            </div>
            {content ? (
                <>
                    {selectedCategory !== "Semua" && (
                        <div className="max-w-7xl mx-auto px-6 md:px-10">
                            <CategoryScoreboard category={selectedCategory} />
                        </div>
                    )}
                    <Prestasi achievements={filteredAchievements} athletes={content.athletes || []} />
                </>
            ) : (
                <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 text-racing-muted">Memuat semua prestasi...</div>
            )}
        </div>
    );
}
